var a=function(a,e,t){var u;return function(v){e.value>=0&&(v||t)&&(e.delta=e.value-(u||0),(e.delta||void 0===u)&&(u=e.value,a(e)))}};export{a as bindReporter};
